jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.leisure-statement').length ) {
        let $ = jQuery;

        $(".statement-signposts").slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            rows: 0,
            dots: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        infinite: true,
                    }
                }
            ]
        });
    }
});